module.exports = __webpack_public_path__ + "static/media/projectImg.14f79e91.svg";